<template>
  <section>
    <div class="d-flex flex-row justify-space-between align-center mb-3">
      <h1 class="section-header__title">
        Админка
      </h1>
    </div>
    <wrapper-preview-category :title="`Текущий этап: ${currentStage}`">
      <div class="d-flex flex-row align-center">
        <v-btn
            v-for="item in [2, 3, 4, 5, 6, 7, 8]"
            :key="item"
            :class="{'orange__v-btn': currentStage === item}"
            :loading="loading"
            @click="changeStageGlobal(item)"
            class="white__v-btn mr-2">
          {{ stageName(item) }}
        </v-btn>
      </div>
    </wrapper-preview-category>
    <wrapper-collapse
        custom-class="orange-border-left"
        :key="a"
        title="Согласование объемов контрольных цифр приема" :initial-open="currentStage === 2 || currentStage === 3">
      <div class="d-flex flex-row my-3 align-center justify-start">
        <v-btn class="white__v-btn"
               :loading="downloadingPrint"
               @click="downloadPrint('ExcelAdmin', 'downloadingPrint',`Общая выгрузка на ${calcDateNow()}.xlsx`, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', '?barcode=123')"
        >
          Общая выгрузка в Excel
        </v-btn>
        <v-btn class="white__v-btn ml-3"
               :loading="downloadingPrintExcel1"
               @click="downloadPrint('ExcelAdminAllOffers', 'downloadingPrintExcel1','Экспорт данных этап 1.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', '?barcode=123')"
        >
          Общая выгрузка предложений не головных оргов в Excel
        </v-btn>

        <v-btn class="white__v-btn ml-3"
               :loading="downloadingPrintExcel2"
               @click="downloadPrint('ExcelContactInformation', 'downloadingPrintExcel2',`Выгрузка контактов ${calcDateNow()}.xlsx`, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', '?barcode=1234')"
        >
          Выгрузка контактов
        </v-btn>
        <v-btn class="white__v-btn ml-3"
               :loading="downloadingPrintExcel3"
               @click="downloadPrint('ExcelAdminCo', 'downloadingPrintExcel3',`Выгрузка ОКЦП по этапу ЦО (${calcDateNow()}).xlsx`, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')"
        >
          Выгрузка ОКЦП по этапу ЦО
        </v-btn>
      </div>
    </wrapper-collapse>
    <wrapper-collapse
        custom-class="orange-border-left"
        :key="b"
        title="Конкурс распределения контрольных цифр приема" :initial-open="currentStage === 4 || currentStage === 5">
      <div class="d-flex flex-row align-end">
        <v-btn class="white__v-btn ml-3"
               :loading="downloadingPrintExcel4"
               @click="downloadPrint('ExcelAdminKcpContacts', 'downloadingPrintExcel4',`Контакты и статусы (${calcDateNow()}).xlsx`, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')"
        >
          Контакты и статусы
        </v-btn>
        <v-btn class="white__v-btn ml-3"
               :loading="downloadingPrintExcel8"
               @click="downloadEx('no_accreditations_f4', 'downloadingPrintExcel8','Заявки без аккредитации.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')"
        >
          Заявки без аккредитации
        </v-btn>
        <v-btn class="white__v-btn ml-3"
               :loading="downloadingPrintExcel7"
               @click="downloadEx('licenses_accreditations', 'downloadingPrintExcel7','Набор данных конкурса КЦП.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')"
        >
          Набор данных конкурса КЦП
        </v-btn>
        <v-btn class="white__v-btn ml-3"
               :loading="downloadingPrintExcel5"
               @click="downloadPrint('ExcelAdminKcpData', 'downloadingPrintExcel5',`Статусы заполнения заявок КЦП (${calcDateNow()}).xlsx`, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')"
        >
          Статусы заполнения заявок КЦП
        </v-btn>
        <v-btn class="white__v-btn ml-3"
               :loading="downloadingPrintExcel6"
               @click="downloadPrint('ExcelAdminKcpDataF2', 'downloadingPrintExcel6',`Данные заявок КЦП (${calcDateNow()}).xlsx`, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')"
        >
          Данные заявок КЦП
        </v-btn>
      </div>
    </wrapper-collapse>
    <wrapper-collapse
        custom-class="orange-border-left"
        :key="c"
        title="Выгрузки" :initial-open="currentStage > 5">
      <div class="d-flex flex-row align-end">
        <v-btn class="white__v-btn ml-3"
               :loading="downloadingPrintExcel9"
               @click="downloadPrint('ApeallsLeftExport', 'downloadingPrintExcel9',`Выгрузка апелляций на сводную оценку и показатели (${calcDateNow()}).xlsx`, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')"
        >
          Выгрузка апелляций на сводную оценку и показатели
        </v-btn>
        <v-btn class="white__v-btn ml-3"
               :loading="downloadingPrintExcel10"
               @click="downloadPrint('ExportKcpAdd', 'downloadingPrintExcel10',`Выгрузка согласований доп КЦП (${calcDateNow()}).xlsx`, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')"
        >
          Выгрузка согласований доп КЦП
        </v-btn>
      </div>
    </wrapper-collapse>
    <wrapper-collapse
        custom-class="orange-border-left"
        :key="d"
        title="Приложения КЦП" :initial-open="currentStage > 5">
      <div class="d-flex flex-column">
        <v-text-field label="Номер приказа" v-model="prikNum" :value="prikNum"></v-text-field>
        <v-text-field label="Дата приказа" v-model="prikDate" :value="prikDate"></v-text-field>
      </div>
      <div class="d-flex flex-row align-end">
        <v-btn class="white__v-btn ml-3"
               :loading="downloadingPrintExcel11"
               @click="getPrilPrikArchive(prikDate, prikNum)"
        >
          Приложения к приказу КЦП (основные)
        </v-btn>
        <v-btn class="white__v-btn ml-3"
               :loading="downloadingPrintExcel12"
               @click="getPrilPrikArchiveNr(prikDate, prikNum)"
        >
          Приложения к приказу КЦП (новые регионы)
        </v-btn>
      </div>
    </wrapper-collapse>
    <!--    <wrapper-preview-category title="CryptoTest">-->
    <!--      <CryptoTest></CryptoTest>-->
    <!--    </wrapper-preview-category>-->
  </section>
</template>

<script>
import WrapperPreviewCategory from "@/components/wrappers/WrapperPreviewCategory";
import WrapperCollapse from "@/components/wrappers/WrapperCollapse";
import {mapActions, mapGetters} from "vuex";
import {setFileFunctions} from "@/mixins/fileFucntions";
import AdminController from "@/controllers/AdminController";
// import CryptoTest from "@/pages/Admin/CryptoTest";

export default {
  name: "Main",
  mixins: [setFileFunctions],
  components: {/*CryptoTest,*/ WrapperPreviewCategory, WrapperCollapse},
  data() {
    return {
      prikDate: "«26» декабря 2023",
      prikNum: 143,
      loading: false,
      a: 'wc0',
      b: 'wc1',
      c: 'wc2',
      d: 'wc3',
    }
  },
  computed: {
    ...mapGetters('checkFilled', {currentStage: 'currentStage'}),
  },
  watch: {
    currentStage() {
      this.a++;
      this.b++
    }
  },

  methods: {
    ...mapActions('checkFilled', {updateAdminInfoBlock: 'updateAdminInfoBlock'}),
    changeStageGlobal(stage) {
      const agree = confirm('Вы уверены?');
      if (!agree)
        return;
      this.loading = true;
      AdminController.setNewStage(stage).finally(() => this.loading = false)
    },
    calcDateNow() {
      function padTo2Digits(num) {
        return num.toString().padStart(2, '0');
      }

      function formatDate(date) {
        console.log(padTo2Digits(date.getHours()), padTo2Digits(date.getMinutes()))
        return [
          date.getFullYear(),
          padTo2Digits(date.getMonth() + 1),
          padTo2Digits(date.getDate()),
        ].join('-') + ' ' + [
          padTo2Digits(date.getHours()),
          padTo2Digits(date.getMinutes()),
        ].join('-')
      }

      return formatDate(new Date())
    },

    stageName(stage) {
      if (stage === 4) {
        return `Этап заявки`
      } else if (stage === 5) {
        return `Отказы от КЦП (Показ сводной оценки)`
      } else if (stage === 6) {
        return `Закрытие отказов и апелляций КЦП`
      } else if (stage === 7) {
        return `Согласование доп КЦП`
      } else if (stage === 8) {
        return `Блокировка доп КЦП`
      } else {
        return `Этап ${stage}`
      }
    }
  },
}
</script>

<style scoped>

</style>